import React, { useMemo } from "react";
import {
  Logo,
  HideSideBar,
  SideBarFooter,
  SideBarDropdown,
  ToggleSmallShow,
  useUserPermissions,
} from "@";
import { sidebarGroups } from "@/shared/components/sidebar/sidebarItems.jsx";

const SideBar = () => {
  const { permissions } = useUserPermissions();
  const memoizedGroups = useMemo(() => sidebarGroups, []);

  // Count dropdowns the user can actually see. When it's a small set
  // (one or two), open them by default so the user isn't left with a
  // collapsed menu they'd have to expand every time.
  const visibleGroupsCount = useMemo(
    () =>
      memoizedGroups.filter((group) =>
        group.canShow
          ? group.canShow
              .split(",")
              .some((permission) => permissions?.[permission])
          : true,
      ).length,
    [memoizedGroups, permissions],
  );

  const openByDefault = visibleGroupsCount <= 1;

  return (
    <>
      <aside
        id="sidebar"
        aria-label="Sidebar"
        className="sidebar fixed start-0 top-0 z-[45] hidden h-screen w-full flex-shrink-0 flex-col overflow-y-auto border-e border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-900 font-normal dark:from-gray-900 dark:via-gray-900 dark:to-gray-950 dark:ring-purple-900/30 md:w-[250px] lg:start-0 lg:z-40 lg:flex lg:h-[calc(100vh-10px)] lg:overflow-visible print:hidden"
      >
        {/* Decorative grain — subtle texture */}
        <div className="pointer-events-none absolute inset-0 opacity-[0.05] [background-image:radial-gradient(circle_at_1px_1px,_currentColor_1px,_transparent_0)] [background-size:24px_24px] dark:opacity-[0.04] lg:rounded-2xl" />



        <HideSideBar />

        <Logo />

        <ul className="sidebar-ul relative flex flex-col px-3 pb-6 lg:h-full lg:overflow-y-scroll [.small_&]:!overflow-visible">
          {memoizedGroups.map((group) => (
            <SideBarDropdown
              id={group.id}
              key={group.id}
              name={group.name}
              urls={group.urls}
              canShow={group.canShow}
              defaultOpen={openByDefault}
            >
              {group.icon}
            </SideBarDropdown>
          ))}
        </ul>
 

        <SideBarFooter />
      </aside>
      <div
        id="sidebarBackdrop"
        className="fixed inset-0 z-[42] hidden bg-gray-900/60 backdrop-blur-sm lg:z-[21] print:hidden"
      ></div>
    </>
  );
};

export default React.memo(SideBar);
